<template>
  <svg :fill='color' @click="trigger" :style="{fontSize:size+'px', '--color': color}" :class="['svgicon',{'svgicon--pointer':pointer}]" aria-hidden="true" @mouseover="svgover" @mouseout="svgout">
    <use :xlink:href="iconName"></use>
  </svg>
  <!-- <div>13123</div> -->
</template>

<script>
export default {
  props: {
    name: String,
    size: {
      type: [String, Number],
      default: '20'
    },
    pointer: {
      type: Boolean,
      default: false,
    },
    color: {

    }
  },
  computed: {
    iconName() {
      return '#icon-' + this.name
    }
  },
  methods: {
    trigger(e) {
      this.$emit('click', e)
    },
    svgover(e) {
      this.$emit('mouseover', e)
    },
    svgout(e) {
      this.$emit('mouseout', e)
    }
  }
};
</script>

<style>
.svgicon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  /* fill: currentColor; */
  fill: currentColor;
  color: var(--color);
  overflow: hidden;
}
.svgicon.svgicon--pointer {
  cursor: pointer;
}

/* .svgicon:last-of-type {     
    fill: red; 
} */
</style>


// WEBPACK FOOTER //
// src/common/components/SvgIcon.vue